import React from 'react';
import PropTypes from 'prop-types';
import { Box, Toolbar } from '@mui/material';

import CustomSearch from 'components/common/customSearchV2';

import classes from './styles';

const CustomTableToolbar = props => {
  const { onSearchCallback, filteredParams } = props;

  const searchValue = filteredParams?.params?.search?.value || '';

  return (
    <Toolbar sx={classes.root}>
      <Box sx={classes.filters}>
        <CustomSearch onSearchCallback={onSearchCallback} searchValue={searchValue} />
      </Box>
      <Box sx={classes.actions}> </Box>
    </Toolbar>
  );
};

CustomTableToolbar.propTypes = {
  onSearchCallback: PropTypes.func.isRequired,
  filteredParams: PropTypes.instanceOf(Object).isRequired,
};

export default CustomTableToolbar;
